import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { AboutPage } from './pages/AboutPage';
import { ContestPage } from './pages/ContestPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { PricingPage } from './pages/PricingPage';
import { DmcaPage } from './pages/DmcaPage';
import { RedditPage } from './pages/RedditPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-12" data-mp="ix60ka6voo1a">
      <Routes data-id="element-13" data-mp="ntmmcxqluqb7">
        <Route path="/" element={<App data-id="element-15" data-mp="nvhb6n4zz2kk" />} data-id="element-14" data-mp="nu65uivwlmrc" />
        <Route path="/about" element={<AboutPage data-id="element-17" data-mp="9ueme2mmbe5y" />} data-id="element-16" data-mp="nrtg3jjwm83q" />
        <Route path="/contest" element={<ContestPage data-id="element-19" data-mp="9vptocf9v41t" />} data-id="element-18" data-mp="9uwtxveqdet6" />
        <Route path="/terms" element={<TermsPage data-id="element-21" data-mp="dv6x70b51r4c" />} data-id="element-20" data-mp="9whnbhpb6rpg" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-23" data-mp="dxt4qzy146mk" />} data-id="element-22" data-mp="dwhzswsukstv" />
        <Route path="/pricing" element={<PricingPage data-id="element-25" data-mp="2497j64z8mazh" />} data-id="element-24" data-mp="248fkume99z5i" />
        <Route path="/dmca" element={<DmcaPage data-id="element-27" data-mp="289rcsyklqwgv" />} data-id="element-26" data-mp="248xoi438zfng" />
        <Route path="/reddit" element={<RedditPage data-id="element-29" data-mp="288g72t7ljen4" />} data-id="element-28" data-mp="28a9hmjlbyj0e" />
      </Routes>
    </BrowserRouter>;
}